const management: Record<string, any> = {
    name: "management",
    path: "/management",
    component: "basic",
    children: [
        // "权限管理"是空壳死菜单（epics.md PERM-01 FR1/FR2 要求从导航移除），本身也没有
        // 实际功能。先注释掉不删，保留恢复余地；对应的 sys_menu 记录暂不动（见批次1设计
        // 文档，仓库 SQL 数据长期落后于测试环境实际数据，删之前需要先连库核实真实 menu_id）。
        // {
        //     name: "management_auth",
        //     path: "/management/auth",
        //     component: "self",
        //     meta: {
        //         title: "权限管理",
        //         i18nTitle: "Routes.management.auth",
        //         requiresAuth: true,
        //         icon: "ic:baseline-security",
        //     },
        // },
        {
            name: "management_role",
            path: "/management/role",
            component: "self",
            meta: {
                title: "角色管理",
                i18nTitle: "Routes.management.role",
                requiresAuth: true,
                icon: "carbon:user-role",
                permissions: ["system:role:list"],
            },
        },
        {
            name: "management_user",
            path: "/management/user",
            component: "self",
            meta: {
                title: "用户管理",
                i18nTitle: "Routes.management.user",
                requiresAuth: true,
                icon: "ic:round-manage-accounts",
                permissions: ["system:user:list"],
            },
        },
        // "路由管理"同上，也是空壳死菜单（epics.md FR1/FR2），同样先注释不删。
        // {
        //     name: "management_route",
        //     path: "/management/route",
        //     component: "self",
        //     meta: {
        //         title: "路由管理",
        //         i18nTitle: "Routes.management.route",
        //         requiresAuth: true,
        //         icon: "material-symbols:route",
        //     },
        // },
    ],
    meta: {
        title: "系统管理",
        i18nTitle: "Routes.management._value",
        icon: "carbon:cloud-service-management",
        order: 4,
    },
}

export default management
